import React from 'react';

export const DivClassNameFactory = (className: string) => (props: any) => (
  <div className={className}>{props.children}</div>
);
